const STATUS = {
  OPEN: 1,
  IN_VALIDATION: 2,
  TO_BE_REVIEWED: 3,
  APPROVED: 4
}

const isOpenStatus = (statusId) => {
  return [STATUS.OPEN, STATUS.TO_BE_REVIEWED].includes(+statusId)
}

const isInValidationStatus = (statusId) => {
  return +statusId === STATUS.IN_VALIDATION
}

const isApprovedStatus = (statusId) => {
  return +statusId === STATUS.APPROVED
}

export { STATUS, isOpenStatus, isInValidationStatus, isApprovedStatus }
